export const USER_HAS_AUTHENTICATED = "userHasAuthenticated";
export const FINISH_AUTHENTICATING = "finishAuthenticating";
export const START_AUTHENTICATING = "startAuthenticating";
export const SET_IS_LOADING = "setIsLoading";
